export default __webpack_public_path__ + "e140455af250b6cca00aa55f1a6fcfd7.png";